// import config from 'config';

// import axios from 'axios'
/* eslint-disable */
import { authHeader } from '@/_helpers'

export const userService = {
    login,
    logout,
    getAll
};

function login(email, password) {
    const requestOptions = {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, password })
    };

    return fetch(`/auth/login`, requestOptions)
        .then(handleResponse)
        .then(data => {
            let user = {
                displayName:data.user.name,
                email:data.user.email,
                photoURL:'/img/user.png',
                providerId: 'loginPass',
                token: data.token
            }
            if (data.token) {
                let expiry = new Date(data.exp * 1000).toUTCString()
                localStorage.setItem('userinfo', JSON.stringify(user))
                localStorage.setItem('accessToken', data.token)

                // console.log(user)
                // this.$store.commit('authentication/setUser', user)
                // this.$store.commit('authentication/setToken', data.token)

                localStorage.setItem('tokenExpiry', expiry)
            }
            return user
        })
}

function logout() {
    // remove user from local storage to log user out
    localStorage.removeItem('user');
}

function getAll() {
    const requestOptions = {
        method: 'GET',
        headers: authHeader()
    };

    return fetch(`/api/users`, requestOptions).then(handleResponse);
}

function handleResponse(response) {
    return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok) {
            if (response.status === 401) {
                // auto logout if 401 response returned from api
                logout();
                location.reload(true);
            }
            const error = (data && data.message) || response.statusText;
            return Promise.reject(error);
        }

        return data;
    });
}